import { Rule } from "antd/es/form";
import { LanguageNameSpaces } from "@shared/types";
import { TranslationKeys } from "@shared/common/i18n/types";

export const getEmailFormItemRules = (
  t: (key: TranslationKeys<LanguageNameSpaces.AUTH>) => string
): Rule[] => [
  {
    type: "email",
    message: t("validation.valid_email"),
  },
  {
    required: true,
    message: t("validation.email_required"),
  },
  {
    max: 255,
    message: t("validation.email_max"),
  },
];

export const EMAIL_FORM_ITEM_RULES: Rule[] = [
  {
    type: "email",
    message: "Please enter a valid email address",
  },
  {
    required: true,
    message: "Please enter your email address",
  },
  {
    max: 255,
    message: "Email address must be 255 characters or less",
  },
];

// Phone keyboards and autofill for email fields: the email keyboard, no
// auto-capitalised first letter, no autocorrect. (The type stays "text" so
// the form's own validation messages show, not the browser's.)
export const EMAIL_INPUT_PROPS = {
  inputMode: "email",
  autoComplete: "email",
  autoCapitalize: "none",
  autoCorrect: "off",
  spellCheck: false,
} as const;
